import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Modal, ModalBody, ModalFoot, ModalHead, } from '@dixa/lib-shared-habla';
import { useCallback, useState } from 'react';
import { useUpdateEffect } from 'react-use';
import { analytics } from 'app/utils/segment';
import { HolidayCalendarSelector } from 'components/settings/components/sections/openingHours/components/holidayCalendarSelector/holidayCalendarSelector';
import { getExceptionsFromHolidays } from 'utils/holidays';
import { useAppSelector } from 'utils/redux/useAppSelector';
import { useScheduleContext, } from '../../../../schedule.context';
export const ImportHolidaysModal = ({ timezone, onClose, onSubmit, }) => {
    const [{ isClosed, countryCode }, setState] = useState({
        countryCode: null,
        isClosed: false,
    });
    const { holidays, getHolidays } = useScheduleContext();
    const agentName = useAppSelector((state) => state.settings.profile.profile.name);
    useUpdateEffect(() => {
        if (!!holidays.length && countryCode) {
            const modifiedItems = getExceptionsFromHolidays({
                agentName,
                holidays: holidays,
                isClosed,
            }).reduce((acc, holiday) => (Object.assign(Object.assign({}, acc), { [holiday.id]: holiday })), {});
            onSubmit(modifiedItems, countryCode);
            onClose();
        }
    }, [holidays]);
    const handleCalendarChange = useCallback((countryCode, isClosed) => {
        if (countryCode) {
            setState({ countryCode, isClosed });
        }
    }, []);
    const handleSubmit = useCallback(() => {
        if (countryCode) {
            analytics.businessHoursScheduleImportHolidayFormSubmitted({
                countryCode,
                isClosed,
            });
            getHolidays(countryCode, timezone);
        }
    }, [countryCode, isClosed, timezone, getHolidays]);
    const handleCancelModal = useCallback(() => {
        analytics.businessHoursScheduleImportHolidayFormCancelled();
        onClose();
    }, [onClose]);
    return (_jsx(Modal, Object.assign({ isOpen: true, onClose: handleCancelModal }, { children: _jsxs(Box, Object.assign({ width: "600px" }, { children: [_jsx(ModalHead, { onClose: handleCancelModal, title: "Connect holiday calendar" }), _jsx(ModalBody, { children: _jsx(HolidayCalendarSelector, { onChange: handleCalendarChange }) }), _jsx(ModalFoot, { cancelOnClick: handleCancelModal, confirmProps: { disabled: !countryCode }, confirmName: "Update", confirmOnClick: handleSubmit })] })) })));
};
